import { useQuery } from "@tanstack/react-query";
import { getScheduleDrafts } from "hooks/api/schedule-draft";

/* eslint-disable react-hooks/rules-of-hooks */

// The acting admin's saved create-schedule drafts, newest-updated first
// (server-ordered). Feeds both the Draft button's count badge and the
// drafts drawer list.
const getScheduleDraftsQuery = () => {
  return useQuery({
    queryKey: ["schedule-drafts"],
    queryFn: getScheduleDrafts,
  });
};

export { getScheduleDraftsQuery };
